import { Modal, Button, Spinner } from 'react-bootstrap';
import { ExclamationTriangle, Trash } from 'react-bootstrap-icons';

const DeleteConfirmationModal = ({ 
    show, 
    onHide, 
    onConfirm, 
    title = "Delete Subscription",
    message = "Are you sure you want to delete this subscription? This action cannot be undone.",
    loading
}) => {
    return (
        <Modal show={show} onHide={onHide} centered backdrop="static">
            <Modal.Body className="p-4 text-center">
                <div className="mb-4">
                <div className="bg-danger bg-opacity-10 rounded-circle d-inline-flex p-3 mb-3">
                    <ExclamationTriangle size={32} className="text-danger" />
                </div>
                <h4 className="mb-2">{title}</h4>
                <p className="text-muted mb-0">{message}</p>
                </div>
                
                <div className="d-flex justify-content-center gap-3">
                <Button 
                    variant="outline-secondary" 
                    onClick={onHide}
                    className="px-4"
                >
                    Cancel
                </Button>
                <Button 
                    variant="danger" 
                    onClick={onConfirm}
                    className="px-4 d-flex align-items-center gap-2"
                >
                    <Trash size={18} />
                    { loading ? <Spinner size='sm'/> : "Delete" }
                </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default DeleteConfirmationModal;